type Props = {
  pct: number;             // 0..100
  size?: number;           // px
  stroke?: number;
  label?: string;
};

export function ProgressRing({ pct, size = 180, stroke = 14, label }: Props) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const dash = (pct / 100) * c;
  const gradId = `pr-grad-${Math.round(pct)}`;

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="rotate-[-90deg]">
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%"  stopColor="#ff3d6b" />
            <stop offset="50%" stopColor="#ffd166" />
            <stop offset="100%" stopColor="#c6ff5e" />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2} cy={size / 2} r={r}
          stroke="#231a3a"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2} cy={size / 2} r={r}
          stroke={`url(#${gradId})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={`${dash} ${c}`}
          style={{ transition: 'stroke-dasharray 0.8s cubic-bezier(0.22, 1, 0.36, 1)' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <div className="font-display font-extrabold text-5xl text-gradient tabular-nums">
          {pct}%
        </div>
        {label && (
          <div className="mt-1 text-xs uppercase tracking-widest text-haze">
            {label}
          </div>
        )}
      </div>
    </div>
  );
}
